export default "https://storage.googleapis.com/prepweb-prod/dist/cf3b3064a014d4ea591160e41c0f9b11.svg";